import React from "react"
import { Line, Arc } from "react-konva"

export default function RectangularSlot(props) {
  const { colorSlot, origin, slot, side, startLens, scaleX, scaleY } = props
  let xDrawEnd, xStartValue, xEndValue
  let line1XStart, line1YStart
  let line2XStart, line2YStart
  let line3XStart, line3YStart
  let line4XStart, line4YStart
  let arc1XStart, arc1YStart
  let arc2XStart, arc2YStart
  let arc3XStart, arc3YStart
  let arc4XStart, arc4YStart
  let pointsLine, verticalPointsLine3, verticalPointsLine4 = []
  let x1, y1, x2, y2, x3, y3, x4, y4
  let distanceX, distanceY, lengthLine
  let radius
  let degreesArc1, degreesArc2, degreesArc3, degreesArc4
  let arc1EndAngleRad, arc1EndX, arc1EndY
  let arc2EndAngleRad, arc2EndX, arc2EndY
  let arc3EndAngleRad, arc3EndX, arc3EndY
  let arc4EndAngleRad, arc4EndX, arc4EndY
  // Format from strings to numbers
  slot.xStart = Number(slot.xStart)
  slot.xEnd = Number(slot.xEnd)
  slot.yStart = Number(slot.yStart)
  slot.yEnd = Number(slot.yEnd)
  slot.diam = Number(slot.diam)

  if (side === "right") {
    //PUNTO 1 (ALTO SX)
    x1 = slot.xStart
    //y1 = slot.yStart
    y1 = slot.yEnd

    //PUNTO 2 (BASSO SX)
    x2 = slot.xStart
    // y2 = slot.yEnd
    y2 = slot.yStart

    //PUNTO 3 (BASSO DX)
    x3 = slot.xEnd
    // y3 = slot.yEnd
    y3 = slot.yStart

    //PUNTO 4 (ALTO DX)
    x4 = slot.xEnd
    // y4 = slot.yStart
    y4 = slot.yEnd

    //calcolo dati retta
    distanceX = x1 - x4
    distanceY = y1 - y4
    lengthLine = Math.sqrt(Math.pow(distanceX, 2) + Math.pow(distanceY, 2))

    //ARCO 1 (ALTO SX)
    arc1XStart = startLens + x1 * scaleX
    arc1YStart = origin.y - y1 * scaleY

    //ARCO 2 (BASSO SX)
    arc2XStart = startLens + x2 * scaleX
    arc2YStart = origin.y - y2 * scaleY

    //ARCO 3 (ALTO DX)
    arc3XStart = startLens + x3 * scaleX
    arc3YStart = origin.y - y3 * scaleY
    //ARCO 4 (BASSO DX)
    arc4XStart = startLens + x4 * scaleX
    arc4YStart = origin.y - y4 * scaleY

    //LINEA 1 
    line1XStart = startLens + (((x4 + (distanceY / lengthLine) * (slot.diam / 2)) + distanceX) * scaleX)
    line1YStart = origin.y - (((y1 - (distanceX / lengthLine) * (slot.diam / 2)) + distanceY) * scaleY)

    //LINEA 2
    line2XStart = startLens + (((x4 - (distanceY / lengthLine) * (slot.diam / 2)) + distanceX) * scaleX)
    line2YStart = origin.y - (((y2 + (distanceX / lengthLine) * (slot.diam / 2)) + distanceY) * scaleY)

    //Valori disegno retta
    xStartValue = startLens + slot.xStart * scaleX
    xEndValue = startLens + slot.xEnd * scaleX
    xDrawEnd = xStartValue - xEndValue
    pointsLine = [0, 0, -xDrawEnd, distanceY * scaleY]
    radius = (slot.diam * scaleX) / 2;

    degreesArc1 = Math.atan2(arc2YStart - arc1YStart, arc2XStart - arc1XStart) * 180 / Math.PI;
    degreesArc2 = Math.atan2(arc3YStart - arc2YStart, arc3XStart - arc2XStart) * 180 / Math.PI;
    degreesArc3 = Math.atan2(arc4YStart - arc3YStart, arc4XStart - arc3XStart) * 180 / Math.PI;
    degreesArc4 = Math.atan2(arc1YStart - arc4YStart, arc1XStart - arc4XStart) * 180 / Math.PI;

    // ARCO 1 – ALTO SINISTRA (correggere angolo finale)
    arc1EndAngleRad = (degreesArc1 + 90) * Math.PI / 180;
    arc1EndX = arc1XStart + radius * Math.cos(arc1EndAngleRad);
    arc1EndY = arc1YStart + radius * Math.sin(arc1EndAngleRad);
    // ARCO 2 – BASSO SINISTRA (ok così)
    arc2EndAngleRad = (degreesArc2 + 90 + 90) * Math.PI / 180;
    arc2EndX = arc2XStart + radius * Math.cos(arc2EndAngleRad);
    arc2EndY = arc2YStart + radius * Math.sin(arc2EndAngleRad);

    // ARCO 3 – BASSO DESTRA (era chiamato arc3, ma è sotto → correggere angolo)
    arc3EndAngleRad = (degreesArc3 + 90) * Math.PI / 180;
    arc3EndX = arc3XStart + radius * Math.cos(arc3EndAngleRad);
    arc3EndY = arc3YStart + radius * Math.sin(arc3EndAngleRad);

    // ARCO 4 – ALTO DESTRA (era chiamato arc4, ma è sopra)
    arc4EndAngleRad = (degreesArc4 + 90 + 90) * Math.PI / 180;
    arc4EndX = arc4XStart + radius * Math.cos(arc4EndAngleRad);
    arc4EndY = arc4YStart + radius * Math.sin(arc4EndAngleRad);

    // LINEA VERTICALE SINISTRA
    line4XStart = arc1EndX;
    line4YStart = arc1EndY;
    verticalPointsLine4 = [
      0,
      0,
      arc2EndX - arc1EndX,
      arc2EndY - arc1EndY,
    ];

    // LINEA VERTICALE DESTRA
    line3XStart = arc3EndX;
    line3YStart = arc3EndY;
    verticalPointsLine3 = [
      0,
      0,
      arc4EndX - arc3EndX,
      arc4EndY - arc3EndY,
    ];
  }
  else {
    //PUNTO 1 (ALTO SX)
    x1 = slot.xStart
    y1 = slot.yStart

    //PUNTO 2 (BASSO SX)
    x2 = slot.xStart
    y2 = slot.yEnd

    //PUNTO 3 (BASSO DX)
    x3 = slot.xEnd
    y3 = slot.yEnd

    //PUNTO 4 (ALTO DX)
    x4 = slot.xEnd
    y4 = slot.yStart

    //calcolo dati retta
    distanceX = x4 - x1
    distanceY = y4 - y1
    lengthLine = Math.sqrt(Math.pow(distanceX, 2) + Math.pow(distanceY, 2))
    //ARCO 1 (ALTO SX)
    arc1XStart = startLens - x1 * scaleX
    arc1YStart = origin.y - y1 * scaleY

    //ARCO 2 (BASSO SX)
    arc2XStart = startLens - x2 * scaleX
    arc2YStart = origin.y - y2 * scaleY

    //ARCO 3 (ALTO DX)
    arc3XStart = startLens - x3 * scaleX
    arc3YStart = origin.y - y3 * scaleY
    //ARCO 4 (BASSO DX)
    arc4XStart = startLens - x4 * scaleX
    arc4YStart = origin.y - y4 * scaleY

    //LINEA 1 
    line1XStart = startLens - (((x1 + (distanceY / lengthLine) * (slot.diam / 2)) + distanceX) * scaleX)
    line1YStart = origin.y - (((y1 - (distanceX / lengthLine) * (slot.diam / 2)) + distanceY) * scaleY)

    //LINEA 2
    line2XStart = startLens - (((x1 - (distanceY / lengthLine) * (slot.diam / 2)) + distanceX) * scaleX)
    line2YStart = origin.y - (((y2 + (distanceX / lengthLine) * (slot.diam / 2)) + distanceY) * scaleY)

    //Valori disegno retta
    xStartValue = startLens + slot.xStart * scaleX
    xEndValue = startLens + slot.xEnd * scaleX
    xDrawEnd = xStartValue - xEndValue
    pointsLine = [0, 0, -xDrawEnd, distanceY * scaleY]
    radius = (slot.diam * scaleX) / 2;

    degreesArc1 = Math.atan2(arc2YStart - arc1YStart, arc2XStart - arc1XStart) * 180 / Math.PI;
    degreesArc2 = Math.atan2(arc3YStart - arc2YStart, arc3XStart - arc2XStart) * 180 / Math.PI;
    degreesArc3 = Math.atan2(arc4YStart - arc3YStart, arc4XStart - arc3XStart) * 180 / Math.PI;
    degreesArc4 = Math.atan2(arc1YStart - arc4YStart, arc1XStart - arc4XStart) * 180 / Math.PI;

    // ARCO 1 – ALTO SINISTRA (correggere angolo finale)
    arc1EndAngleRad = (degreesArc1 + 90) * Math.PI / 180;
    arc1EndX = arc1XStart + radius * Math.cos(arc1EndAngleRad);
    arc1EndY = arc1YStart + radius * Math.sin(arc1EndAngleRad);
    // ARCO 2 – BASSO SINISTRA (ok così)
    arc2EndAngleRad = (degreesArc2 + 90 + 90) * Math.PI / 180;
    arc2EndX = arc2XStart + radius * Math.cos(arc2EndAngleRad);
    arc2EndY = arc2YStart + radius * Math.sin(arc2EndAngleRad);

    // ARCO 3 – BASSO DESTRA (era chiamato arc3, ma è sotto → correggere angolo)
    arc3EndAngleRad = (degreesArc3 + 90) * Math.PI / 180;
    arc3EndX = arc3XStart + radius * Math.cos(arc3EndAngleRad);
    arc3EndY = arc3YStart + radius * Math.sin(arc3EndAngleRad);

    // ARCO 4 – ALTO DESTRA (era chiamato arc4, ma è sopra)
    arc4EndAngleRad = (degreesArc4 + 90 + 90) * Math.PI / 180;
    arc4EndX = arc4XStart + radius * Math.cos(arc4EndAngleRad);
    arc4EndY = arc4YStart + radius * Math.sin(arc4EndAngleRad);

    // LINEA VERTICALE SINISTRA
    line4XStart = arc1EndX;
    line4YStart = arc1EndY;
    verticalPointsLine4 = [
      0,
      0,
      arc2EndX - arc1EndX,
      arc2EndY - arc1EndY,
    ];

    // LINEA VERTICALE DESTRA
    line3XStart = arc3EndX;
    line3YStart = arc3EndY;
    verticalPointsLine3 = [
      0,
      0,
      arc4EndX - arc3EndX,
      arc4EndY - arc3EndY,
    ];
  }


  return (
    <React.Fragment>
      <Arc
        x={arc1XStart}
        y={arc1YStart}
        innerRadius={(slot.diam * scaleX) / 2}
        outerRadius={(slot.diam * scaleX) / 2}
        angle={90}
        stroke={colorSlot}
        strokeWidth={1}
        rotation={degreesArc1 + 90}
      />
      <Arc
        x={arc2XStart}
        y={arc2YStart}
        innerRadius={(slot.diam * scaleX) / 2}
        outerRadius={(slot.diam * scaleX) / 2}
        angle={90}
        stroke={colorSlot}
        strokeWidth={1}
        rotation={degreesArc2 + 90}
      />

      <Arc
        x={arc3XStart}
        y={arc3YStart}
        innerRadius={(slot.diam * scaleX) / 2}
        outerRadius={(slot.diam * scaleX) / 2}
        angle={90}
        stroke={colorSlot}
        strokeWidth={1}
        rotation={degreesArc3 + 90}
      />

      <Arc
        x={arc4XStart}
        y={arc4YStart}
        innerRadius={(slot.diam * scaleX) / 2}
        outerRadius={(slot.diam * scaleX) / 2}
        angle={90}
        stroke={colorSlot}
        strokeWidth={1}
        rotation={degreesArc4 + 90}
      />

      <Line
        x={line1XStart}
        y={line1YStart}
        points={pointsLine}
        stroke={colorSlot}
        strokeWidth={1}

      />
      <Line
        x={line2XStart}
        y={line2YStart}
        points={pointsLine}
        stroke={colorSlot}
        strokeWidth={1}
      />

      <Line
        x={line3XStart}
        y={line3YStart}
        points={verticalPointsLine3}
        stroke={colorSlot}
        strokeWidth={1}
      />
      <Line
        x={line4XStart}
        y={line4YStart}
        points={verticalPointsLine4}
        stroke={colorSlot}
        strokeWidth={1}
      />

    </React.Fragment>

  )
}